export default __webpack_public_path__ + "static/speaker7-f605f83dfb2f45ffaf837799cd205b85.jpg";